import { render, staticRenderFns } from "./Register-empresa.vue?vue&type=template&id=88fb84f6&"
import script from "./Register-empresa.vue?vue&type=script&lang=js&"
export * from "./Register-empresa.vue?vue&type=script&lang=js&"
import style0 from "./Register-empresa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports